import { useLocation } from 'react-router-dom';

import { isMlbPage } from 'constants/routes';

export const useIsMlbPage = () => {
  const location = useLocation();

  return isMlbPage(location.pathname);
};
